import React from "react";
import "./Socials.css";
import { socials } from "../../data";

const Socials = () => {
  return (
    <div>
      <ul className="socials">
        {socials.map((link) => (
          <li key={link.media}>
            <a href={link.url}>
              <img src={link.icon} className="social__icon" />{" "}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Socials;
